module.exports = __webpack_public_path__ + "static/media/light_fixture_suspended_zku.c488ddc4.png";